goog.provide("shadow.js.shim.module$lottie_light_react$default");
shadow.js.shim.module$lottie_light_react$default = shadow.js.require(175, {})["default"];
